import styled from 'styled-components';

export const ScenarioContainer = styled.div``;

export const ScenarioHeader = styled.div`
	color: white;
	background-color: #004294;
	min-height: 3rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${({ theme }) => `${theme.padding.edge}`};
`;

export const ScenarioContentContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ScenarioMainContent = styled.div`
	display: grid;
	grid-template-columns: clamp(15rem, 20vw, 20rem) 1fr;
	gap: 1rem;
	border: ${({ theme }) => `2px solid ${theme.background.primary}`};
	border-top: none;
`;

export const ScenarioSidebar = styled.div`
	border-right: ${({ theme }) => `2px solid ${theme.background.primary}`};
	padding: ${({ theme }) => `${theme.padding.edge}`};
	max-height: 45vh;
	min-height: 30vh;
	overflow-y: auto;
`;

export const ScenarioChartContainer = styled.div`
	padding: ${({ theme }) => `${theme.padding.edge}`};
`;

export const ScenarioConfig = styled.div`
	display: flex;
	align-items: center;
	border: ${({ theme }) => `2px dashed ${theme.background.primary}`};
	border-top: none;

	& > div:not(:last-child) {
		border-right: ${({ theme }) => `2px dashed ${theme.background.primary}`};
	}
`;

export const ScenarioConfigItem = styled.div`
	padding: ${({ theme }) => `${theme.padding.edge}`};
`;
